import _ from 'lodash';
import React, { Component } from 'react';
import { EDITOR_DESKTOP_LEFT_BAR_MENU_ID } from 'crazyEditor/core/constants/editorConstants';
import { connect } from 'react-redux';
import { setSelectedElementIds } from 'crazyEditor/redux/modules/stage/stage';
import DraggableMenuElement from '../MenuElement/DraggableMenuElement';
import styles from '../EditorLeftBarStyles';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { elementTypes } from 'crazyEditor/components/Elements/index';
import { isPageElementSelected, isBackgroundElementSelected } from 'crazyEditor/redux/modules/element/elementSelectors';
import { addDesktopElement } from 'crazyEditor/core/elements/utils/elementAddUpdateUtils';
import {getNormalizedTemplateTagSpecifics} from 'crazyEditor/redux/modules/templateTagSet/templateTagSelectors';
import * as Colors from 'material-ui/styles/colors';
import { getElementPreset } from 'crazyEditor/core/elements/utils/elementDefinitionUtils';
import { emphasize } from 'material-ui/utils/colorManipulator';
import InlineButton from 'shared/components/InlineButton';
import Scrollbars from 'shared/vendor/react-custom-scrollbars/src/Scrollbars/index';

@connect(
  state => ({
    isResizingElement: state.stage.isResizingElement,
    isBackgroundElementSelected: isBackgroundElementSelected(state),
    isPageElementSelected: isPageElementSelected(state),
    isDraggingElement: state.stage.isDraggingElement,
    selectedElementIds: state.stage.selectedElementIds,
    stageLayoutTop: state.stage.layout.top,
    stageLayoutHeight: state.stage.layout.height,
    left: state.stage.layout.left,
    templateTagSetName: state.templateTagSet.name,
    templateTagSetLink: state.templateTagSet.link,
    templateTagSpecifics: getNormalizedTemplateTagSpecifics(state),
  }),
  {setSelectedElementIds}
)
@Radium
export default class TemplateTagElementsMenu extends Component {
  render() {
    const { open, templateTagSpecifics, isResizingElement, isDraggingElement, stageLayoutHeight, left, templateTagSetLink } = this.props;
    const galleryPreset = getElementPreset(elementTypes.GalleryElement);
    return (
      <div
        style={[styles.secondLevelMenuContainer, (isResizingElement || isDraggingElement) && {pointerEvents: 'none'}, {transform: open ? null : 'translateX(-105%)'}]}
      >
        <Scrollbars>
          <ul style={[styles.menuContainer]}>
            <li
              style={{fontSize: 14, color: 'white', marginTop: 20, marginLeft: 16, marginRight: 16, marginBottom: 10}}
            >
              The elements below are place holders.
              They are not editable via the editor, and will be automatically populated with your products data. <InlineButton href={templateTagSetLink} target="_blank">Read more</InlineButton>
            </li>
          </ul>
          <ul style={[styles.menuContainer]}>
            <DraggableMenuElement
              stageLayoutHeight={stageLayoutHeight}
              left={left}
              label="product image gallery"
              responsive={false}
              onClick={() => addDesktopElement(elementTypes.GalleryElement, null, galleryPreset)}
              onDrop={position => addDesktopElement(elementTypes.GalleryElement, position, galleryPreset)}
              elementPreset = {galleryPreset}
              backgroundColor={styles.secondLevelMenuContainer.backgroundColor}
              hoverColor = {emphasize(Colors.grey600)}
              key="galleryInTagMenu"
            />
            {
              _.map(_.sortBy(_.filter(templateTagSpecifics, 'displayName'), 'order'),
                (templateTag) => {
                  return (<DraggableMenuElement templateTag = {templateTag}
                                                stageLayoutHeight={stageLayoutHeight}
                                                label={templateTag.displayName}
                                                left={left}
                                                onClick={() => addDesktopElement(elementTypes.TitleElement, null, _.merge({data: {templateTag: templateTag.name}}, templateTag.preset))}
                                                onDrop={position => addDesktopElement(elementTypes.TitleElement, position, _.merge({data: {templateTag: templateTag.name}}, templateTag.preset))}
                                                key={templateTag.name}
                                                responsive={false}
                                                elementPreset = {_.merge({}, getElementPreset(elementTypes.TitleElement), templateTag.preset)}
                                                backgroundColor={styles.secondLevelMenuContainer.backgroundColor}
                                                hoverColor = {emphasize(Colors.grey600)}
                  />);
                })
            }
          </ul>
        </Scrollbars>
      </div>
    );
  }
}

TemplateTagElementsMenu.propTypes = {
  open: PropTypes.bool,
};